export default "__VITE_ASSET__DKUVbzkE__"